import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosError } from 'axios';

import { CompanyUser, UserList, UserLess } from '@models/User';
import { UserApi } from '@apis/UserApi';
import { SagaPayload } from '@utils/typescript';
import { UserOtpCodeApi } from '@apis/UserOtpCodeApi';
import { getResponseError } from '@utils/error';

import {
  companyUsersFetch,
  frontlineUsersFetch,
  otpCodeRequest,
  OtpCodeRequestPayload,
  userFind,
  UserFindPayload,
  userSave,
  UserSavePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleCompanyUsersFetch() {
  const state: StateUpdatePayload = { companyUsers: [] };
  try {
    state.companyUsers = (yield call(UserApi.getAllCompanyUsers)) as CompanyUser[];
    yield put(stateUpdate(state));
  } catch { }
}

function* handleFrontlineUsersFetch() {
  const state: StateUpdatePayload = { frontlineUsers: [] };
  try {
    state.frontlineUsers = (yield call(UserApi.getAllFrontlineUsers)) as UserList[];
    yield put(stateUpdate(state));
  } catch { }
}

function* handleOtpCodeRequest({ payload }: SagaPayload<OtpCodeRequestPayload>) {
  yield call(UserOtpCodeApi.create, payload);
}

function* handleUserFind({ payload }: SagaPayload<UserFindPayload>) {
  try {
    const user = (yield call(UserApi.find, payload)) as UserLess;
    const state: StateUpdatePayload = { user };
    yield put(stateUpdate(state));
  } catch { }
}

function* handleUserSave({ payload }: SagaPayload<UserSavePayload>) {
  try {
    const user = (yield call(UserApi.save, payload)) as UserLess;
    const state: StateUpdatePayload = { user, isSuccess: true };
    yield put(stateUpdate(state));
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { serverErrors };
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(companyUsersFetch, handleCompanyUsersFetch);
  yield takeLatest(frontlineUsersFetch, handleFrontlineUsersFetch);
  yield takeLatest(otpCodeRequest, handleOtpCodeRequest);
  yield takeLatest(userFind, handleUserFind);
  yield takeLatest(userSave, handleUserSave);
}
